<template>
    <div  class="fixed-footer">
        
    <div>

        <div id="s-Page_footer"  class="group">
             <div id="s-Paragraph_1" class="sidebyside widthcompanyName paragraphend">
                   
               
             </div>
             <div id="s-Paragraph_2" class="sidebyside widthTerms paragraph">
               
                       <span id="rtr-s-Paragraph_2_0">About Us | Contact Us| Help   </span>
                     
             </div>
             <div id="s-Paragraph_3" class="rightalign widthcompanyName paragraphend" >
               
                       
               </div>
           </div>
    </div>
    </div>
</template>
<script>
    
    export default {
        data() {
            return {
              
            };
        },
        components: {
            
        }
    }
</script>
<style scoped>
.group {display: flex;
    flex-direction: row;
   
    border: 1px black solid;
    margin: 0 auto;}

.widthcompanyName{
    width:30%
}
.widthTerms{
    width:40%
}
.sidebyside {
    padding-left: 1%;
 padding-right: 1%;
    float:left; 
    
}

.paragraphend {
        font-size: 8pt;
    
}
.rightalign{
   padding-left: 1%;
 padding-right: 1%;
 display: flex;
  justify-content: flex-end;
        
}

.paragraph {
    color: rgb(74, 134, 232);
    text-align: center;
    font-family: Arial, Arial;
    font-size: 8pt;
    font-style: normal;
    font-weight: 700;
    text-decoration: none;
}
    .bottom-footer {
       background-color: white;
  padding : 5px;
  text-align: left;
  color: #3399ff;
  border : 2px solid #3399ff;
  font-size: 10px;
  margin : auto;
    }
</style>
